import { useEffect, useState } from "react";
import { X, Download } from "lucide-react";
import { useLang } from "@/context/LangContext";

const DISMISS_KEY = "jayek_install_dismissed";

export default function InstallPrompt() {
  const { lang } = useLang();
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (localStorage.getItem(DISMISS_KEY)) return;
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShow(true);
    };
    window.addEventListener("beforeinstallprompt", handler);
    // Hide if already installed
    if (window.matchMedia("(display-mode: standalone)").matches) {
      setShow(false);
    }
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  if (!show || !deferredPrompt) return null;

  const onInstall = async () => {
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === "accepted") {
      localStorage.setItem(DISMISS_KEY, "installed");
    }
    setShow(false);
    setDeferredPrompt(null);
  };

  const onDismiss = () => {
    localStorage.setItem(DISMISS_KEY, "dismissed");
    setShow(false);
  };

  return (
    <div
      className="fixed bottom-20 md:bottom-6 inset-x-4 md:left-auto md:right-6 md:w-80 z-[9999] bg-white rounded-2xl shadow-2xl border border-[#EAEAEA] p-4 flex items-center gap-3 animate-in slide-in-from-bottom duration-300"
      data-testid="install-prompt"
    >
      <div className="w-12 h-12 rounded-xl bg-[#E05D3A] flex items-center justify-center flex-shrink-0">
        <Download className="w-5 h-5 text-white" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="font-bold text-sm text-[#1A1A1A]">
          {lang === "ar" ? "ثبّت جايك على جوالك" : "Install Jayek on your phone"}
        </p>
        <p className="text-xs text-[#6B6B6B] mt-0.5 truncate">
          {lang === "ar" ? "أسرع، وبدون تنزيل من المتجر" : "Faster, no app store needed"}
        </p>
      </div>
      <button
        onClick={onInstall}
        className="text-xs font-bold bg-[#E05D3A] text-white rounded-full px-4 py-2 hover:bg-[#C24B2C] flex-shrink-0"
        data-testid="install-btn"
      >
        {lang === "ar" ? "تثبيت" : "Install"}
      </button>
      <button
        onClick={onDismiss}
        className="w-7 h-7 rounded-full hover:bg-[#F5F5F5] flex items-center justify-center flex-shrink-0"
        data-testid="install-dismiss"
      >
        <X className="w-4 h-4 text-[#6B6B6B]" />
      </button>
    </div>
  );
}
